<!-- Certifirma Digital Virtual (clásico / código) y P10 -->
<section class="download-panel download-tv-codigo" *ngIf="esDescargaActiva" id="tour-target-admin-download">
  <div class="dl-toolbar" *ngIf="step !== 'entry' && step !== 'otp' && step !== 'listo'">
    <button type="button" class="dl-cancel-link" (click)="reiniciar()" [disabled]="procesoEnCurso">
      <i class="fas fa-arrow-left" aria-hidden="true"></i>
      Cancelar
    </button>
  </div>

  <nav class="dl-progress" aria-label="Progreso de descarga">
    <div class="dl-progress-item" [class.is-current]="step === 'entry'" [class.is-done]="step !== 'entry'">
      <span class="dl-progress-num">1</span>
      <span class="dl-progress-label">Solicitud</span>
    </div>
    <span class="dl-progress-line" [class.is-done]="step !== 'entry'"></span>
    <div class="dl-progress-item" [class.is-current]="step === 'otp'" [class.is-done]="step === 'acceso' || step === 'listo'">
      <span class="dl-progress-num">2</span>
      <span class="dl-progress-label">Código OTP</span>
    </div>
    <span class="dl-progress-line" [class.is-done]="step === 'acceso' || step === 'listo'"></span>
    <div class="dl-progress-item" [class.is-current]="step === 'acceso'" [class.is-done]="step === 'listo'">
      <span class="dl-progress-num">3</span>
      <span class="dl-progress-label">{{ etiquetaPasoAcceso }}</span>
    </div>
    <span class="dl-progress-line" [class.is-done]="step === 'listo'"></span>
    <div class="dl-progress-item" [class.is-current]="step === 'listo'" [class.is-done]="step === 'listo'">
      <span class="dl-progress-num">4</span>
      <span class="dl-progress-label">Listo</span>
    </div>
  </nav>

  <div class="download-panel-card" *ngIf="errorMessage">
    <p class="dl-error" role="alert">{{ errorMessage }}</p>
  </div>

  <!-- Paso 1: entrada -->
  <div class="download-panel-card" *ngIf="step === 'entry'">
    <div class="download-panel-icon" aria-hidden="true"><i class="fas fa-hashtag"></i></div>
    <div class="download-panel-copy dl-form-block">
      <h2>Número de solicitud</h2>
      <p>
        Ingresa el número de solicitud con el que se registró el certificado.
      </p>
      <label class="dl-label" for="orden-id-input">Número de solicitud *</label>
      <div class="auth-input-wrap">
        <input
          id="orden-id-input"
          type="text"
          class="auth-input"
          inputmode="numeric"
          autocomplete="off"
          placeholder="Ej. 123456"
          [(ngModel)]="ordenIdInput"
          (keydown.enter)="submitOrdenId()"
          [disabled]="loading" />
      </div>
      <div class="dl-actions">
        <button type="button" class="btn btn-primary" (click)="submitOrdenId()" [disabled]="loading || !ordenIdInput.trim()">
          <span *ngIf="!loading">Continuar</span>
          <span *ngIf="loading"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Consultando…</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Paso 2: OTP -->
  <div class="download-panel-card" *ngIf="step === 'otp' && session">
    <div class="download-panel-icon" aria-hidden="true"><i class="fas fa-envelope-open-text"></i></div>
    <div class="download-panel-copy dl-form-block">
      <h2>Verifica tu identidad</h2>
      <p class="dl-welcome" *ngIf="nombreSaludo">
        Hola, <strong>{{ nombreSaludo }}</strong>.
      </p>
      <p *ngIf="!otpEnviado">
        Enviaremos un código al correo
        <strong>{{ correoOfuscado }}</strong>
        asociado a tu solicitud
        <strong>{{ session.solicitudTitularId }}</strong>.
      </p>
      <p *ngIf="otpEnviado">
        Escribe los <strong>4 dígitos</strong> enviados a
        <strong>{{ correoOfuscado }}</strong>
        (solicitud <strong>{{ session.solicitudTitularId }}</strong>) y confirma con el botón.
      </p>

      <div class="dl-actions" *ngIf="!otpEnviado">
        <button type="button" class="btn btn-primary" (click)="enviarOtp()" [disabled]="loading">
          <span *ngIf="!loading">Enviar código</span>
          <span *ngIf="loading"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Enviando…</span>
        </button>
        <button type="button" class="btn btn-secondary" (click)="reiniciar()" [disabled]="loading">
          Cambiar solicitud
        </button>
      </div>

      <ng-container *ngIf="otpEnviado">
        <app-otp-verification-block
          [otpLength]="4"
          [expiresInSeconds]="60"
          [timerRestartKey]="otpResendKey"
          [errorMessage]="otpError"
          [validating]="loading"
          [showLeadText]="false"
          [showCancelButton]="true"
          [showResendLink]="true"
          hintText="¿No llega el correo? Revisa spam, promociones o “Todos los correos”."
          (submitCode)="onOtpSubmit($event)"
          (resend)="enviarOtp()"
          (cancel)="reiniciar()">
        </app-otp-verification-block>
      </ng-container>
    </div>
  </div>

  <!-- Paso 3: acceso TV -->
  <form
    *ngIf="step === 'acceso' && session && !esP10"
    [formGroup]="accesoForm"
    (ngSubmit)="autenticarYEmitir()"
    novalidate
    class="dl-acceso-form"
    [attr.aria-busy]="procesoEnCurso">
    <div class="download-panel-card download-panel-card--acceso">
      <div class="download-panel-icon" aria-hidden="true">
        <i class="fas fa-key"></i>
      </div>
      <div class="download-panel-copy dl-form-block">
        <h2>Contraseña de acceso</h2>
        <p class="dl-welcome" *ngIf="nombreSaludo">
          {{ nombreSaludo }}, define o confirma tu contraseña para continuar.
        </p>
        <p *ngIf="esTvCodigo">
          La contraseña del Certifirma Digital Virtual con código debe tener 10–12 caracteres, mayúscula, número y carácter especial.
          Luego autenticaremos en CCSW5.
        </p>
        <p *ngIf="esTvClasico">
          Si ya asignaste una antes, úsala para acceder a tus certificados vigentes en Certifirma Digital Virtual.
          Si es la primera vez, crea una (mínimo 8 caracteres, mayúscula, número y carácter especial).
        </p>

        <fieldset class="dl-acceso-fieldset" [disabled]="procesoEnCurso">
          <div class="dl-acceso-grid">
            <div class="dl-acceso-fields">
              <label class="dl-label" for="dl-pass">Contraseña *</label>
              <div class="auth-input-wrap auth-input-wrap-password dl-pass-wrap">
                <input
                  id="dl-pass"
                  [type]="showPass ? 'text' : 'password'"
                  formControlName="contrasena"
                  class="auth-input"
                  [class.auth-input-masked]="!showPass"
                  [attr.maxlength]="passwordMaxLength"
                  autocomplete="new-password" />
                <button type="button" class="password-toggle-btn" (mousedown)="showPass = true" (mouseup)="showPass = false"
                  (mouseleave)="showPass = false" tabindex="-1" aria-label="Ver contraseña">
                  <i class="fas fa-eye" aria-hidden="true"></i>
                </button>
              </div>

              <label class="dl-label" for="dl-pass-confirm">Confirmar contraseña *</label>
              <div class="auth-input-wrap auth-input-wrap-password dl-pass-wrap" [class.is-invalid]="muestraErrorPassNoCoincide">
                <input
                  id="dl-pass-confirm"
                  [type]="showPassConfirm ? 'text' : 'password'"
                  formControlName="confirmar"
                  class="auth-input"
                  [class.auth-input-masked]="!showPassConfirm"
                  [attr.maxlength]="passwordMaxLength"
                  autocomplete="new-password" />
                <button type="button" class="password-toggle-btn" (mousedown)="showPassConfirm = true" (mouseup)="showPassConfirm = false"
                  (mouseleave)="showPassConfirm = false" tabindex="-1" aria-label="Ver confirmación">
                  <i class="fas fa-eye" aria-hidden="true"></i>
                </button>
              </div>
              <p class="dl-error-inline" *ngIf="muestraErrorPassNoCoincide" role="alert">
                Las contraseñas no coinciden.
              </p>
            </div>

            <aside class="dl-acceso-reqs" aria-label="Requisitos de la contraseña">
              <p class="dl-reqs-title">Requisitos</p>
              <ul class="req-list">
                <li *ngIf="esTvCodigo" [class.ok]="hasCcsw5Length">Entre 10 y 12 caracteres</li>
                <li *ngIf="esTvClasico" [class.ok]="hasMinLength">8–12 caracteres</li>
                <li [class.ok]="hasUpper">Al menos una mayúscula</li>
                <li [class.ok]="hasNumber">Al menos un número</li>
                <li [class.ok]="hasSpecial">Al menos un carácter especial</li>
              </ul>
            </aside>
          </div>

          <div class="dl-auth-status" *ngIf="esTvCodigo && (esperandoAuth || emitiendo || ventanaAuthCerrada)">
            <p *ngIf="esperandoAuth && !ventanaAuthCerrada">
              <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
              Completa el inicio de sesión en la ventana de CCSW5…
            </p>
            <p *ngIf="ventanaAuthCerrada && !emitiendo">
              La ventana de autenticación se cerró. Puedes reintentar.
            </p>
            <p *ngIf="emitiendo">
              <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
              Emitiendo certificado…
            </p>
          </div>

          <div class="dl-auth-status" *ngIf="esTvClasico && emitiendo">
            <p>
              <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
              Obteniendo certificado…
            </p>
          </div>
        </fieldset>

        <div class="dl-actions dl-actions--bar">
          <button type="submit" class="btn btn-primary" [disabled]="!puedeAutenticar">
            <ng-container *ngIf="esTvCodigo">
              <span *ngIf="!registrando && !esperandoAuth && !emitiendo">Autenticar y generar</span>
              <span *ngIf="registrando"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Registrando…</span>
              <span *ngIf="esperandoAuth || emitiendo"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> En proceso…</span>
            </ng-container>
            <ng-container *ngIf="esTvClasico">
              <span *ngIf="!emitiendo">Obtener certificado</span>
              <span *ngIf="emitiendo"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Obteniendo…</span>
            </ng-container>
          </button>
          <button type="button" class="btn btn-secondary" *ngIf="esTvCodigo && ventanaAuthCerrada && !emitiendo"
            (click)="reintentarAuth()" [disabled]="registrando || procesoEnCurso">
            Reabrir autenticación
          </button>
        </div>
      </div>
    </div>
  </form>

  <!-- Paso 3: acceso P10 -->
  <div class="download-panel-card" *ngIf="step === 'acceso' && session && esP10">
    <div class="download-panel-icon" aria-hidden="true">
      <i class="fas fa-file-lines"></i>
    </div>
    <div class="download-panel-copy dl-form-block">
      <!-- P10: llave privada + .cer -->
      <ng-container>
        <h2>Descarga Certifirma Digital PKCS10</h2>
        <p class="dl-welcome" *ngIf="nombreSaludo">
          Hola, <strong>{{ nombreSaludo }}</strong>.
        </p>
        <p>
          Solicitud <strong>{{ session.solicitudTitularId }}</strong>.
          <ng-container *ngIf="!session.existeCSR">
            Primero genera la llave privada (se envía a <strong>{{ correoOfuscado }}</strong>) y luego descarga el .cer.
          </ng-container>
          <ng-container *ngIf="session.existeCSR">
            Tu llave ya está lista. Puedes descargar el certificado público (.cer).
          </ng-container>
        </p>

        <div class="dl-actions" *ngIf="!session.existeCSR">
          <button type="button" class="btn btn-primary" (click)="generarLlaveP10()" [disabled]="procesoEnCurso">
            <span *ngIf="!generandoLlave">Generar llave privada</span>
            <span *ngIf="generandoLlave"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Generando…</span>
          </button>
        </div>

        <div class="dl-p10-key-box" *ngIf="session.existeCSR && llavePrivadaAdjunto && !llavePrivadaDescargada">
          <p class="dl-hint">La llave también se envió al correo. ¿Deseas guardarla en este equipo?</p>
          <div class="dl-actions">
            <button type="button" class="btn btn-primary" (click)="descargarLlavePrivadaLocal()" [disabled]="procesoEnCurso">
              Descargar .key
            </button>
            <button type="button" class="btn btn-secondary" (click)="omitirDescargaLlave()" [disabled]="procesoEnCurso">
              Continuar sin descargar
            </button>
          </div>
        </div>

        <div class="dl-actions" *ngIf="session.existeCSR">
          <button type="button" class="btn btn-primary" (click)="obtenerCerP10()" [disabled]="procesoEnCurso">
            <span *ngIf="!emitiendo">Descargar .cer</span>
            <span *ngIf="emitiendo"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Obteniendo…</span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Paso 4: listo -->
  <div class="download-panel-card dl-success-card" *ngIf="step === 'listo' && certificado" role="status" aria-live="polite">
    <div class="dl-success-icon" aria-hidden="true">
      <i class="fas fa-check"></i>
    </div>
    <div class="download-panel-copy dl-form-block dl-success-copy">
      <p class="dl-success-badge">Proceso exitoso</p>
      <h2 *ngIf="nombreSaludo">¡Listo, {{ nombreSaludo }}!</h2>
      <h2 *ngIf="!nombreSaludo">¡Certificado asignado!</h2>
      <p class="dl-success-lead">
        Tu certificado digital quedó asignado correctamente
        <ng-container *ngIf="session">a la solicitud <strong>{{ session.solicitudTitularId }}</strong></ng-container>.
      </p>
      <p class="dl-success-cta-text" *ngIf="!esP10">
        Ya puedes firmar desde CertiTool con tu Certifirma.
      </p>
      <p class="dl-success-cta-text" *ngIf="esP10">
        Une tu llave privada (.key) con el certificado (.cer) para generar el PFX e instalarlo.
      </p>
      <div class="dl-actions">
        <button
          type="button"
          class="btn btn-success"
          *ngIf="certificado.estado === 'DESCARGA' && certificado.certificadoB64 && certificado.tipo !== 'PFX'"
          (click)="descargarCerSiAplica()">
          Descargar .cer
        </button>
        <button type="button" class="btn btn-success" *ngIf="esP10" (click)="irAUnirLlaves()">
          Unir llaves
        </button>
        <button type="button" class="btn btn-success" *ngIf="!esP10" (click)="irAFirmar()">
          Firmar
        </button>
        <button type="button" class="btn btn-secondary" (click)="reiniciar()">Nueva consulta</button>
      </div>
    </div>
  </div>
</section>
